/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gateway_Card_Feature_ApikeysInputs */



/**
* | output |
* | --- |
* | "Multiple API keys for different projects" |
*
* @param {Gateway_Card_Feature_ApikeysInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const gateway_card_feature_apikeys = /** @type {((inputs?: Gateway_Card_Feature_ApikeysInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gateway_Card_Feature_ApikeysInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Mehrere API-Schlüssel für verschiedene Projekte")
	return /** @type {LocalizedString} */ ("Multiple API keys for different projects")
});